"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint no-param-reassign: 0 */
var cookieUtils = {
  getCookie: function getCookie(key) {
    var document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;
    var value = "; ".concat(document.cookie);
    var parts = value.split("; ".concat(key, "=")); // if multiple cookies with same key just get the last one

    if (parts.length >= 2) {
      return parts.pop().split(';').shift();
    }

    return undefined;
  },
  setCookie: function setCookie(key, value, expires) {
    var document = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.document;

    if (typeof expires === 'undefined') {
      // Set default expires to 1 year if 'undefined',
      // allow 'null' to be used for no expiration
      expires = new Date(new Date().getTime() + 365 * 86400000).toGMTString;
    }

    document.cookie = "".concat(key, "=").concat(value, ";path=/").concat(expires ? ";expires=".concat(expires) : '');
  },
  setCookieV2: function setCookieV2(_ref) {
    var key = _ref.key,
        value = _ref.value,
        _ref$expires = _ref.expires,
        expires = _ref$expires === void 0 ? '' : _ref$expires,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? '' : _ref$domain;
    window.document.cookie = "".concat(key, "=").concat(value, ";path=/").concat(expires ? ";expires=".concat(expires) : '').concat(domain ? ";domain=".concat(domain) : '');
  },
  deleteCookie: function deleteCookie(key) {
    var document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;
    document.cookie = "".concat(key, "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/");
  },
  getCookiePartialList: function getCookiePartialList(partialKey) {
    var document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;
    var matchingPairs = [];
    document.cookie.split('; ').map(function (key) {
      var matches = key.match(new RegExp("(.*".concat(partialKey, "[^=]*)=(.*)")));

      if (matches) {
        matchingPairs.push([matches[1], matches[2]]);
      }
    });
    return matchingPairs;
  },
  getValueFromAdobeAnalyticsCookie: function getValueFromAdobeAnalyticsCookie() {
    var valueKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;
    var analyticsCookiePartialKey = 'AMCV_';
    var arrayOfMatches = cookieUtils.getCookiePartialList(analyticsCookiePartialKey, document);
    var analyticsEncodedData = arrayOfMatches && !(0, _isEmpty2.default)(arrayOfMatches[0]) ? arrayOfMatches[0][1] : undefined;

    if (analyticsEncodedData) {
      var analyticsInternalDataArray = decodeURI(analyticsEncodedData).split('|');

      if (valueKey !== undefined) {
        var _iterator = _createForOfIteratorHelper(analyticsInternalDataArray.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
                index = _step$value[0],
                data = _step$value[1];

            var internalValue = data === valueKey ? analyticsInternalDataArray[index + 1] : undefined;

            if (internalValue) {
              return internalValue;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        return analyticsInternalDataArray[0];
      }
    }

    return undefined;
  }
};
var _default = cookieUtils;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/utils/cookieUtils.js
// module id = 81
// module chunks = 25